import type { JobApplication } from '../job-applications/types';

export type OpportunityType = 'jobPosting' | 'spontaneousApplication';

export type JobPosting = {
  id: string;
  publishedAt: string;
  title: string;
  description: string;
  remote: boolean;
  directApply: boolean;
  location: string;
  employmentType: string;
  url: string;
  identifier: string;
  company: {
    name: string;
    description: string | null;
    industry: string | null;
  };
  provider?: {
    name: string;
    jobPostingId: string;
  };
  opportunityType?: OpportunityType;
  isPartner?: boolean;
  learningPaths: Array<{
    id: number;
    title: string;
  }>;
};

export type UserJobPosting = JobPosting & {
  jobApplication: JobApplication | null;
};

export type JobPostingListItem = Omit<
  JobPosting,
  'employmentType' | 'url' | 'identifier' | 'provider'
>;

export type OrganizationJobPosting = {
  id: number;
  createdAt: string;
  publishedAt: string | null;
  unpublishedAt: string | null;
  expirationDate: string;
  deactivationReason: string | null;
  publicationStatus: 'draft' | 'published' | 'unpublished';
  title: string;
  description: string;
  remote: Array<'full' | 'no' | 'partial'>;
  location: {
    label: string;
    city: string;
    country: string;
    state: string;
    postalCode?: string;
    latitude: number;
    longitude: number;
    providerId: string;
  };
  learningPaths: Array<{
    id: number;
    title: string;
  }>;
  languageProficiencies: {
    language: string;
    level: string;
  }[];
  certificationLevels: string[];
  contractTypes: string[];
  salaryRange: {
    monthlyMin: number;
    monthlyMax: number;
    currency: 'EUR' | 'USD';
  } | null;
  organizationUser: {
    userId: number;
    organizationId: string;
  };
};

export const MONTHLY_MAX_VALUE = 999999;
